import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";
import log from "loglevel";
import { DropdownLinkOption, Navbar, type DropdownOptionUnion } from "@avlino-inc/alenza-react";
import { getTheme } from "lib/theme";
import {
  logoutUserAction,
  refreshJwtAction,
} from "store/actions/actionCreators";
import * as routes from "routes";
import { DropdownLinkElement } from "@avlino-inc/alenza-react/lib/components/Forms/atoms/Dropdown/Local";

const MainNav = ({
  first_name,
  last_name,
  username,
  email,
}: {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [theme, setTheme] = useState<string | undefined>();
  const [usernameState, setUsernameState] = useState<string>();

  useEffect(() => {
    log.info("MainNav useEffect()...");
    setTheme(getTheme());
    setUsernameState(username);
  }, [username]);

  useEffect(() => {
    const refreshIntervalMinutes = 15;
    const interval = setInterval(() => {
      log.info("Refreshing JWT...");
      dispatch(refreshJwtAction({}));
    }, refreshIntervalMinutes * 60 * 1000);

    return () => clearInterval(interval);
  });

  const onHandleLogout = useCallback(
    (option: DropdownLinkOption) => {
      // NOTE: Moved to dropdown component in design library
      // event.preventDefault();
      ReactGA.event({
        category: "Logout",
        action: `Successful Logout from User: ${usernameState}`,
      });
      dispatch(logoutUserAction({}));
      let url = option.url || routes.LOGIN;
      history.push(url);
    },
    [history, usernameState]
  );

  const onClickUserCard = useCallback(() => history.push(routes.SETTINGS), []);

  const dropdownItems = {
    title: first_name && last_name ? `${first_name} ${last_name}` : "",
    options: [
      {
        key: "accounts",
        label: "Accounts",
        url: `${routes.ACCOUNTS}`,
      },
      {
        key: "dashboard",
        label: "Dashboard",
        url: `${routes.DASHBOARD_MAIN}`,
      },
      {
        key: "settings",
        label: "Settings",
        url: `${routes.SETTINGS}`,
      },
      {
        key: "aicon",
        label: "Back to AiCON",
        url: `${routes.AICON_DUMMY_ROUTE}`,
      },
      Navbar.Dropdown.Divider,
      {
        key: "logout",
        label: "Log out",
        url: `${routes.LOGIN}`,
        onClick: onHandleLogout,
        props: { style: { color: "red" } },
      },
    ],
  };

  return (
    <Navbar
      logoUrl="/"
      productNameUrl="/dashboard"
      moduleName="Command Center"
      email={email}
      onClickUserCard={onClickUserCard}
      dropdown={dropdownItems}
    />
  );
};

export default MainNav;
